import React, { useState, useEffect } from 'react';
import { 
  RadioGroup, 
  FormControlLabel, 
  Radio,
  Card,
  Box
} from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledCard = styled(Card)({
  padding: '0px',
  backgroundColor: 'transparent',
  maxWidth: '400px',
  boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
  borderRadius: '0px'
});

const StyledFormControlLabel = styled(FormControlLabel)({
  width: '100%',
  margin: 0,
  padding: '5px 25px 5px 0px',
  borderRadius: '4px',
  '&:hover': {
    backgroundColor: 'rgba(0, 0, 0, 0.04)',
  },
  '& .MuiRadio-root': {
    color: '#1976d2',
  },
  '& .MuiTypography-root': {
    fontSize: '12px',
  }
});

const SelectionBox = ({
  selectionName,
  selectionChecked,
  selectionSwitch,
  selectionZoom,
  selectionOptions,
  selectionValue,
  selectionChange,


}) => {


  return (
      <div >
        <div className="Building-title pl-15">{selectionName}</div>
        {selectionSwitch && <label className="layer-toggle-switch">
          <input type="checkbox" checked={selectionChecked} onChange={selectionSwitch} />
          <span className="layer-toggle-slider layer-toggle-round"></span>
        </label>}
        {selectionZoom ? <div className="Building-result-none">Zoom in to refresh</div> : null}

            <StyledCard>
              <RadioGroup 
                value={selectionValue} 
                onChange={selectionChange}
                className="space-y-2"
              >
                {selectionOptions.map((option) => (
                  <StyledFormControlLabel
                    key={option.value}
                    value={option.value}
                    control={<Radio />}
                    label={option.label}
                  />
                ))}
              </RadioGroup>
            </StyledCard>
      </div>
  );
};

export default SelectionBox;
